import PropTypes from 'prop-types'

import MenuSection from './MenuSection'
import StyledMenu from './StyledMenu'

const Menu = ({ className, content, trackFooterNavigation, isAppRoute }) => (
  <StyledMenu className={`menu ${className}`}>
    <nav className="menu-content">
      {content.map((menuSection) => {
        return (
          <MenuSection
            menuSection={menuSection}
            key={menuSection.sys.id}
            trackFooterNavigation={trackFooterNavigation}
            isAppRoute={isAppRoute}
          />
        )
      })}
    </nav>
  </StyledMenu>
)

Menu.propTypes = {
  className: PropTypes.string,
  content: PropTypes.arrayOf(PropTypes.object),
  isAppRoute: PropTypes.func,
  trackFooterNavigation: PropTypes.func,
}
Menu.defaultProps = {}

export default Menu
